<!--
    描述：用户管理
    时间：2021-06-18
    Created by 王帅
-->
<template>
	<div class="filter-layout">
		<!-- 筛选区域 -->
		<div class="filter-box">
			<el-form :model="searchForm"
					 ref="searchForm"
					 v-show="filterShow"
					 label-width="110px">
				<el-row>
					<el-col :span="5">
						<el-form-item label="姓名"
									  prop="sname">
							<el-input :placeholder="'请输入'"
									  clearable
									  v-model="searchForm.sname"
									  size="small">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="用户名"
									  prop="username">
							<el-input :placeholder="'请输入'"
									  clearable
									  v-model="searchForm.username"
									  size="small">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="手机号"
									  prop="phone">
							<el-input :placeholder="'请输入'"
									  clearable
									  v-model="searchForm.phone"
									  size="small">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5"
							v-if="this.userInfo.roleType===1">
						<el-form-item label="所属单位"
									  prop="deptName">
							<el-select v-model="searchForm.deptName"
									   placeholder="请选择"
									   filterable
									   size="small">
								<el-option v-for="(item, index) in unitList"
										   :key="'单位' + index"
										   :label="item.sname"
										   :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="5"
							v-if="this.userInfo.roleType!==1">
						<el-form-item label="">
						</el-form-item>
					</el-col>
					<el-col :span="4"
							class="text-right">
						<el-form-item label-width="0">
							<el-button type="primary"
									   icon="el-icon-search"
									   class="btn-blue"
									   size="small"
									   @click="doSearch">查询</el-button>
							<el-button size="small"
									   icon="el-icon-refresh"
									   @click="resetSearch">重置</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!-- 筛选折叠按钮 -->
			<div class="control-btn"
				 @click="filterShow = !filterShow">
				<span v-if="filterShow">
					点击收起
					<svg-icon icon-class="pack-up"
							  class="c-icon ml5"></svg-icon>
				</span>
				<span v-else>筛选
					<svg-icon icon-class="pack-down"
							  class="c-icon ml5"></svg-icon>
				</span>
			</div>
		</div>

		<!-- 主体内容区域 -->
		<div class="filter-content primary-layout">
			<div class="primary-header">
				<div class="left-text"></div>
				<div class="btnGroups">
					<el-button size="small"
							   type="success"
							   v-if="roleBtns.includes('platform_user_add')"
							   @click="addUser">新增用户</el-button>
					<el-button size="small"
							   icon="el-icon-refresh"
							   type="primary"
							   @click="resetSearch"></el-button>
				</div>
			</div>
			<div class="primary-content">
				<UserTable ref="listTable"
						   @handleTool="handleTool"
						   :searchParams="searchForm"></UserTable>
			</div>
		</div>

		<!-- 弹窗 -->
		<el-dialog :visible.sync="dialogObj.visible"
				   :title="dialogObj.title"
				   :width="dialogObj.width"
				   :before-close="doCancel"
				   destroy-on-close
				   center
				   top="10vh"
				   :close-on-click-modal="false"
				   @close="doCancel">
			<UserDetail ref="detailUser"
						v-if="dialogObj.visible"
						:curUser="currentRow"
						:curMode="dialogObj.type"></UserDetail>

			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.type != 'view'">
				<el-button size="small"
						   @click="doCancel">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">保 存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
// components
import UserTable from './components/user_table'
import UserDetail from './platform_user_detail'

// js
import { mapState } from 'vuex'
import { saveOrUpdatePlatformUser } from 'api/system/user.js'
import { getListTenants } from 'api/system/sysTenant.js'
export default {
	name: '',
	components: {
		UserTable,
		UserDetail,
	},
	data() {
		return {
			filterShow: true,
			filterData: [],
			searchForm: {
				sname: '',
				username: '',
				phone: '',
				deptName: '',
				stationId: '',
			},
			loading: false,
			// 弹窗
			dialogObj: {
				visible: false,
				title: '新增用户',
				width: '80%',
				type: 'add',
			},
			btnLoading: false,
			unitList: [],
			currentRow: {},
			//筛选框
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			searchToggle: true,
			tableShow: true,
		}
	},
	created() {
		this.getUnitList()
	},
	methods: {
		// 点击新增
		addUser() {
			this.dialogObj.visible = true
			this.dialogObj.title = '新增用户'
			this.dialogObj.type = 'add'
		},

		// 弹窗保存
		async doSave() {
			this.btnLoading = true
			let status = await this.$refs.detailUser.doSave()

			if (status) {
				let params = this.$refs.detailUser.baseForm
				params.roleIds ? '' : (params.roleIds = [])
				saveOrUpdatePlatformUser(params)
					.then((res) => {
						this.btnLoading = false
						if (res.operationCode != 1 || res.msg == 'faild') {
							this.$message.error(res.data)
							return
						}
						this.$message.success('保存成功！')
						this.doCancel()
						this.doSearch()
					})
					.catch((err) => {
						this.btnLoading = false
					})
			} else {
				this.btnLoading = false
			}
		},

		// 弹窗关闭
		doCancel() {
			this.currentRow = {}
			this.dialogObj.visible = false
			this.btnLoading = false
		},

		// 操作
		handleTool(params) {
			this.currentRow = this.$utils.clone(params.row, true)

			this.dialogObj.visible = true
			this.dialogObj.title =
				params.type === 'edit' ? '编辑用户资料' : '查看用户资料'
			this.dialogObj.type = params.type
		},

		// 获取所属单位列表
		getUnitList() {
			getListTenants({})
				.then((res) => {
					this.unitList = res.data
				})
				.catch((err) => {})
		},

		// 点击查询
		doSearch() {
			this.$refs.listTable.getTablePageList('1')
		},

		// 重置查询
		resetSearch() {
			this.$refs.searchForm.resetFields()
			this.$refs.listTable.getTablePageList('1')
		},
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo,
			roleType: (state) => state.userInfo.roleType, // 1 是超级管理员  0 是普通
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
}
</script>

<style scoped lang="less">
.filter-layout {
	.filter-box {
		padding-top: 10px;
	}
}
</style>
